import FavoriteButton from '../shared/favorite-button.vue';
import loginmodal from '../shared/login-modal.vue';
import NoResults from '../shared/no-results.vue';
import contactnew from './contact-new.vue';
import contactused from './contact-used.vue';

import * as Constants from "../scripts/constants";
import detailsClient from '../scripts/services/detailsClient';
import UserClientService from "../scripts/services/userClient.js";
import advertiserLocationClient from "../scripts/services/advertiserLocationsClient.js";


new Vue({
    el: "#detail",
    components: {
        contactused,
        contactnew,
        loginmodal,
        NoResults,
        FavoriteButton
    },

    data() {
        return {
            isFavorite: false,
            IdPub: "",
            IdAdvert: "",
            LocationContact:{
                Show: false,
                Phone: "",
                Website: ""
            }
        }
    },

    methods: {

        // ------------------------------- FAVORITE --------------------------------------------------
        async OnFavoriteClick() {
            var r = await UserClientService.SetFavorite(this.IdPub);
            if (r != null) {
                if (r.OK) {
                    this.isFavorite = !this.isFavorite;

                    this.$emit('SetFavoriteSuccess', { IsFavorite: this.IsFavorite, IdPub: this.IdPub });

                } else {
                    if (r.StatusCode == Constants.HTTP_STATUS_CODE_UNAUTHORIZED) {
                        this.isFavorite = false;


                        if ($("#favoritesLoginModal").length > 0) {
                            $("#favoritesLoginModal").modal();
                        }
                        else {
                            if ($("#loginModal").length > 0) {
                                $("#loginModal").modal();
                            } else {
                                UserClientService.OnUnauthorized();
                            }
                        }
                    }
                }
            }
        },

        async OnShowLocationContact(id, advert){
            var r = await advertiserLocationClient.GetContacto(id,advert);
            if (r != null) {
                this.LocationContact.Phone = r.Phone;
                
                if (r.Website != null && r.Website.startsWith("http") == false)
                    r.Website = "https://" + r.Website;
                this.LocationContact.Website = r.Website;
                
                this.LocationContact.Show = true;
            }
        },

        async OnClickPhone(id, advert){
            await advertiserLocationClient.PostClickPhone(id,advert);
        },

        // -------------------------------- BUTTONS --------------------------------------------------
        async reportAd() {
            await detailsClient.ReportAd(this.IdAdvert, window.location.pathname)
        },

        async onPrintAd() {
            window.print()
        },

        shareOnFacebook() {
            var url = encodeURIComponent(window.location.href);
            var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
            window.open(shareUrl, '_blank');
        },

        shareOnTwitter() {
            var url = encodeURIComponent(window.location.href);
            var tweetText = encodeURIComponent("Vejam este anúncio: ");
            var shareUrl = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + tweetText;
            window.open(shareUrl, '_blank');
        },

        shareOnWhatsApp() {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            const url = encodeURIComponent(window.location.href);

            if (isMobile) {
                const shareUrl = `whatsapp://send?text=${url}`;
                window.location.href = shareUrl;
            } else {
                const webShareUrl = `https://web.whatsapp.com/send?text=${url}`;
                window.open(webShareUrl, '_blank');
            }
        },
    },

    created() {
        if (isFav != null)
            this.isFavorite = isFav
        if (idPub)
            this.IdPub = idPub
        if (idAdvert)
            this.IdAdvert = idAdvert
    }
})
